import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, PanelLeftClose } from 'lucide-react';
import { AppShell as OsAppShell, Spinner } from '@os/ui';
import { useUi } from '@/stores/ui.store';
import { Sidebar } from './Sidebar';

export const BRAND = { mark: 'DS', name: 'Distributor' };

/**
 * OS shell (232px dark sidebar + main column). The expanded sidebar carries a small collapse arrow; when collapsed a
 * hamburger in the page header (and a floating one on screens without a header) brings it back — the same
 * mechanics as the sibling apps (Bayyinah), so every app behaves identically.
 */
export function AppShell() {
  const { menuOpen, setMenuOpen, sidebarCollapsed, setSidebarCollapsed } = useUi();
  return (
    <div className={`ds-shell${sidebarCollapsed ? ' is-collapsed' : ''}`} style={sidebarCollapsed ? { ['--sidebar-w' as string]: '0px' } : undefined}>
      <OsAppShell brand={BRAND} menuOpen={menuOpen} onMenuOpenChange={setMenuOpen} sidebar={({ onNavigate }) => (
        <div className="ds-side-wrap">
          <Sidebar onNavigate={onNavigate} />
          <button type="button" className="ds-side-collapse" onClick={() => setSidebarCollapsed(true)} aria-label="Collapse menu" title="Collapse menu">
            <PanelLeftClose size={16} strokeWidth={1.5} />
          </button>
        </div>
      )}>
        {sidebarCollapsed && (
          <button type="button" className="ds-side-open" onClick={() => setSidebarCollapsed(false)} aria-label="Show menu" title="Show menu">
            <Menu size={18} strokeWidth={1.5} />
          </button>
        )}
        <Suspense fallback={<div style={{ display: 'grid', placeItems: 'center', flex: 1, minHeight: 300 }}><Spinner /></div>}>
          <Outlet />
        </Suspense>
      </OsAppShell>
    </div>
  );
}
